<template lang="html">
	<div class="form">
		<div class="row wtf">
			<div class="cols s_24 m___8">
				<label>
					<input type="text"
							:placeholder='field1.placeholder'
							v-model='client_name'>

					<span class="validation-error" :error='showRequiredName'>
						<span class="required">{{field1.validator}}</span>
					</span>
				</label>
			</div>

			<div class="cols s_24 m___8">
				<label class='phone'>
					<input type="text"
							:placeholder='field2.placeholder'
							v-model='client_phone'>
					<span class="validation-error" :error='showRequiredPhone'>
						<span class="required">{{field2.validator}}</span>
					</span>
				</label>
			</div>

			<div class="cols s_24 m___8">
				<label class='email'>
					<input type="text"
							:placeholder='field3.placeholder'
							v-model='client_email'>
					<span class="validation-error" :error='showRequiredEmail'>
						<span class="required">{{field3.validator}}</span>
					</span>
				</label>
			</div>
		</div>

		<div class="row">
			<div class="cols s_24">
				<div class="text1">{{data.text1}}</div>
			</div>
		</div>

		<div class="row">
			<div class="cols s_24 m___5 l_9 l__8">
				<label>
					<input type="text"
							:placeholder='field4.placeholder'
							v-model='client_skype'>
				</label>
			</div>

			<div class="cols s_24 m___19 l_15 l__16">
				<div class="checkboxes">
					<label v-for='btn in fields5_6'>
						<input type="radio"
						 		:name='btn.name'
								:value='btn.value'
								v-model='place'>
						<span class="ok"></span>
						<span class="txt">{{btn.text}}</span>
					</label>

					<span class="validation-error" :error='showRequiredPlace'>
						<span class="required">{{data.place}}</span>
					</span>
				</div>
			</div>
		</div>

		<div class="row end">
			<div class="cols s_24 m___6 l_8">
				<div class="submit">
					<button @click='click'>{{data.button}}</button>
				</div>
			</div>
		</div>

		<grecaptcha
			:request='request'
			:payload='payload'
			@SENDFORM='onRecaptchaSubmit'
		/>
	</div>
</template>

<script>
const Inputmask = require('inputmask');

module.exports = {
	name: 'bx24-demo',

	props: {
		data: {
			type: Object,
			required: true
		}
	},

	components: {
		grecaptcha: require('./elements/grecaptcha.vue'),
	},

	data() {
		return {
			client_name: '',
			client_phone: '',
			client_email: '',
			client_skype: '',
			place: '',

			completeName: false,
			completePhone: false,
			completeEmail: false,
			completePlace: false,

			showRequiredName: false,
			showRequiredPhone: false,
			showRequiredEmail: false,
			showRequiredPlace: false,
			grcID: null,

			payload: {}
		}
	},

	computed: {
		field1() {
			return this.data.fields ? this.data.fields[0] : {};
		},
		field2() {
			return this.data.fields ? this.data.fields[1] : {};
		},
		field3() {
			return this.data.fields ? this.data.fields[2] : {};
		},
		field4() {
			return this.data.fields ? this.data.fields[3] : {};
		},
		fields5_6() {
			return this.data.fields ? [this.data.fields[4], this.data.fields[5]] : [];
		},

		request() {
			return this.data ? this.data.request : {};
		}
	},

	methods: {
		onRecaptchaSubmit(payload) {
			this.$emit('SENDFORM', payload);
		},
		click() {
			if(!this.client_skype.length && !this.place) {
				this.completePlace = false;
			}

			if(this.completeName && this.completePhone && this.completeEmail && this.completePlace) {
				// console.log(this.data);
				this.payload = {
					[this.field1.name]: this.client_name,
					[this.field2.name]: this.client_phone,
					[this.field3.name]: this.client_email,
					[this.field4.name]: this.client_skype,
					[this.fields5_6[0].name]: this.place
				}
			}
			else {

				if(!this.completeName) {
					this.showRequiredName = true;
				}
				if(!this.completePhone) {
					this.showRequiredPhone = true;
				}
				if(!this.completeEmail) {
					this.showRequiredEmail = true;
				}
				if(!this.completePlace) {
					this.showRequiredPlace = true;
				}

			}
		}
	},

	watch: {
		client_name() {
			if(this.client_name.length >= 2) {
				this.completeName = true;
				this.showRequiredName = false;
			}
			else {
				this.completeName = false;
			}
		},
		client_skype() {
			if(this.client_skype.length) {
				// console.log(this.client_skype.length);
				this.place = '';
				this.completePlace = true;
				this.showRequiredPlace = false;
			}
		},
		place() {
			if(this.place != '') {
				this.client_skype = '';
				this.completePlace = true;
				this.showRequiredPlace = false;
			}
		}
	},

	mounted() {

		this.$parent.$on('clear', () => {
			this.client_name = '',
			this.client_phone = this.field2.value;
			this.client_email = '',
			this.client_skype = '',
			this.place = '',

			this.completeName = false,
			this.completePhone = false,
			this.completeEmail = false,
			this.completePlace = false,

			this.showRequiredName = false,
			this.showRequiredPhone = false,
			this.showRequiredEmail = false,
			this.showRequiredPlace = false
		})

		this.$on('clear', () => {
			this.client_phone = this.field2.value;
		})

		let timerid = setTimeout(() => {
		  this.$emit('clear');
	  }, 1000);

		let phone = new Inputmask({
			mask: window.YAMASTERS_FRONTEND.validator.mask.tel.default,
			definitions: {
				'9': '',
				'x': {
					validator: "[0-9\\s]",
					cardinality: 1,
					casing: "lower"
				}
			},
			oncomplete: () => {
				console.log('tel oncomplete');
				this.completePhone = true;
				this.showRequiredPhone = false;
			},
			onincomplete: () => {
				console.log('tel oncomplete');
				this.completePhone = false;
			},
			oncleared: () => {
				console.log('tel oncleared');
				this.completePhone = false;
			}
		});

		phone.mask(this.$el.querySelector('.phone input'));


		let email = new Inputmask({
			mask: window.YAMASTERS_FRONTEND.validator.mask.email,
			greedy: false,
			definitions: {
				'*': {
					validator: "[0-9A-Za-z_-]",
					cardinality: 1,
					casing: "lower"
				},
				'@': {
					validator: '@',
					cardinality: 1,
					casing: 'lower'
				},
				'd': {
					validator: '.',
					cardinality: 1,
					casing: 'lower'
				}
			},
			oncomplete: () => {
				// console.log('oncomplete');
				this.completeEmail = true;
				this.showRequiredEmail = false;
			},
			onincomplete: () => {
				this.completeEmail = false;
			},
			oncleared: () => {
				this.completeEmail = false;
			}
		});

		email.mask(this.$el.querySelector('.email input'))
	}
}
</script>

<style lang="scss">
	@import "scss/wanted";

	.VForm.bx24-demo {

		.form {
			max-width: rem(285);
			margin: 0 auto;
			@include m___up {
				max-width: none;
			};

			[grecaptcha] {
				display: none;
			}

			label {
				display: block;
				position: relative;

				input {

					&[type='text'] {
						height: rem(61);
						border-radius: rem(30);
						border: 1px solid #989A9E;
						text-align: center;
						color: #303339;
						margin: 0 0 rem(15);
						padding: 0 rem(25);
						@include single-transition;
						@include placeholder {
							color: #97999c;
							opacity: 1;
						};
						@include m___up {
							text-align: left;
						};

						&:focus {
							border-color: #2B3036;
						}
					}
				}

				.validation-error {
					position: absolute;
					left: rem(25);
					right: rem(25);
					font-size: rem(12);
					color: #00B3E9;
					display: block;
					z-index: 1;
					@include s_up {
						top: rem(43);
						text-align: center;
					};
					@include m___up {
						top: calc(100% - 10px);
						text-align: left;
					};

					&[error] .required {
						opacity: 1;
						transform: translateY(0px);
					}

					.required {
						display: block;
						transform: translateY(5px);
						opacity: 0;
						@include single-transition;
					}
				}
			}

			.text1 {
				font-size: rem(18);
				color: #303339;
				line-height: rem(30);
				margin: 0 0 rem(23);
				padding: rem(23) 0 0;
			}

			.checkboxes {
				padding: rem(13) 0 0;
				margin: 0 0 rem(26);
				position: relative;
				@include m___up {
					display: flex;
					align-items: center;
					margin: 0;
					padding: rem(20) 0 0;
				};

				label {
					display: flex;
					align-items: center;
					justify-content: center;
					margin: 0 0 rem(14);
					cursor: pointer;
					position: static;
					@include s___up {
						justify-content: flex-start;
					};
					@include m___up {
						margin: 0 rem(30) 0 0;
						&:last-child {
							margin: 0;
						}
					};

					input {
						display: none;

						&:checked {
							& ~ .ok {
								border-color: #fff;

								&:after {
									opacity: 1;
								}
							}

							& ~ .txt {
								color: #2fc7f7;
							}
						}
					}

					.ok {
						display: block;
						width: rem(18);
						height: rem(18);
						border: rem(2) solid #989A9E;
						border-radius: rem(1);
						margin: 0 rem(10) 0 0;
						position: relative;
						@include single-transition;
						transform: translateY(-1px);

						&:after {
							content: '';
							background: url('#{$imgPathSCSS}checked.png') no-repeat center;
							background-size: 100% 100%;
							position: absolute;
							top: rem(-2);
							right: rem(-2);
							bottom: rem(-2);
							left: rem(-2);
							opacity: 0;
							@include single-transition;
						}
					}

					.txt {
						display: block;
						color: #97999c;
						@include single-transition;
					}
				}

				.validation-error {
					position: absolute;
					top: 100%;
					left: 0;
					right: 0;
					text-align: center;
					font-size: rem(12);
					color: #00B3E9;
					display: block;
					@include s___up {
						text-align: left;
					};
					@include m___up {
						top: calc(100% + 5px);
					};

					&[error] .required {
						opacity: 1;
						transform: translateY(0px);
					}

					.required {
						display: block;
						transform: translateY(5px);
						opacity: 0;
						@include single-transition;
					}
				}
			}

			.submit {
				@include m___up {
					padding: rem(15) 0 0;
				};

				button {
					height: rem(61);
					border-radius: rem(30);
					background-color: #E6DF39;
					border: none;
					color: #303339;
					@include single-transition;

					&:hover {
						background-color: #dcd829;
					}

					&:active {
						background-color: #CFCA34;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// bx24-demo.vue?24daf38e